import { render, staticRenderFns } from "./card-item.vue?vue&type=template&id=bf42c7c8&"
import script from "./card-item.vue?vue&type=script&lang=js&"
export * from "./card-item.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports